// Angular modules.
import { Injectable } from '@angular/core';
// RxStomp
import { RxStompService } from '@stomp/ng2-stompjs';
import { Message } from '@stomp/stompjs';
import { environment } from 'environments/environment';

// Zenklub services.
import { EventsService } from './events.service';

@Injectable()
export class StompService {
	// Constructor.
	constructor(
		private events: EventsService,
		private rxStompService: RxStompService
	) {}

	public connectToAppointmentsTopic(userId: string): void {
		// subscribe for events updates
		const value = environment.rabbitmq.toppics.appointments + userId;
		this.rxStompService.watch(value).subscribe(
			(message: Message) => {
				// in here we need to update the event
				const event = JSON.parse(message.body);
				if (event.status === 'cancelled') {
					return;
				}
				this.events.verifyNewEvent(event);
			},
			(error) => {
				throw new Error(error);
			}
		);
	}

	public disconnect() {
		// disconnect from rabbit
		this.rxStompService.deactivate();
	}
}
